import {
    GET_REPORT_TYPES,
    GET_ALL_REPORTS,
    GET_REPORT_KEYS,
    SET_MONTH,
    SET_TO_MONTH,
    SET_YEAR,
    SET_REPORT_TYPE,
    GET_JOBPACK_REPORTS,
    BUILD_EXCEL_DOC,
    GET_HSQE_TEMPLATE,
    SET_SPECIFIC_TEMPLATE,
    GET_VEHICLE_ALERTS,
    GET_DOWNLOADS,
    SET_NEW_DOWNLOAD,
} from "./types";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import XLSX from "xlsx";
import _ from "lodash";
export const getReportTypes = () => {
    return (dispatch) => {
        dispatch({ type: GET_REPORT_TYPES.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/collections/report_titles`)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_REPORT_TYPES.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else {
                    dispatch({ type: GET_REPORT_TYPES.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_REPORT_TYPES.FAIL });
        }
    };
};
export const getReports = () => {
    return (dispatch) => {
        dispatch({ type: GET_ALL_REPORTS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/subjects/reports/`)
                        .on("value", (snapshot) => {
                            return dispatch({
                                type: GET_ALL_REPORTS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else dispatch({ type: GET_ALL_REPORTS.FAIL });
            });
        } catch {
            dispatch({ type: GET_ALL_REPORTS.FAIL });
        }
    };
};
export const getJobPackReports = () => {
    return (dispatch) => {
        dispatch({ type: GET_JOBPACK_REPORTS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/subjects/jobpacks/`)
                        .on("value", (snapshot) => {
                            return dispatch({
                                type: GET_JOBPACK_REPORTS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else dispatch({ type: GET_JOBPACK_REPORTS.FAIL });
            });
        } catch {
            dispatch({ type: GET_JOBPACK_REPORTS.FAIL });
        }
    };
};

export const getReportKeys = () => {
    return (dispatch) => {
        dispatch({ type: GET_REPORT_KEYS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/collections/report_keys/`)
                        .on("value", (snapshot) => {
                            return dispatch({
                                type: GET_REPORT_KEYS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else dispatch({ type: GET_REPORT_KEYS.FAIL });
            });
        } catch {
            dispatch({ type: GET_REPORT_KEYS.FAIL });
        }
    };
};
export const setMonth = (date = false) => {
    return (dispatch) => {
        dispatch({ type: SET_MONTH, payload: date });
    };
};
export const setToMonth = (date = false) => {
    return (dispatch) => {
        dispatch({ type: SET_TO_MONTH, payload: date });
    };
};
export const setYear = (date = false) => {
    return (dispatch) => {
        dispatch({ type: SET_YEAR, payload: date });
    };
};
export const setReportType = (reportType = false) => {
    return (dispatch) => {
        dispatch({ type: SET_REPORT_TYPE, payload: reportType });
    };
};
export const getExcelDoc = (userReports, reportType) => {
    return (dispatch, getStore) => {
        let labels =
            _.get(
                getStore(),
                `DashboardV2_reducer.BuildExcelDocWidget_reducer.reportKeys.${reportType}`
            ) || false;
        let titles =
            _.get(
                getStore(),
                `DashboardV2_reducer.BuildExcelDocWidget_reducer.reportTypes`
            ) || false;

        dispatch({ type: BUILD_EXCEL_DOC.REQUEST });
        if (labels) {
            try {
                if (Array.isArray(userReports[0])) {
                    userReports.unshift(labels);
                    const ws_name = `${reportType}`;

                    const fileName = `${reportType}-report.xlsx`;

                    const wb = XLSX.utils.book_new();
                    let ws = wb.Sheets[wb.SheetNames[0]];
                    ws = XLSX.utils.aoa_to_sheet(userReports);
                    XLSX.utils.book_append_sheet(wb, ws, ws_name);

                    XLSX.writeFile(wb, fileName);
                } else {
                    userReports.map((e) => {
                        Object.keys(e).map((report) => {
                            Object.keys(e[report]).map((key) => {
                                delete Object.assign(e[report], {
                                    [labels[key]]: e[report][key],
                                })[key];
                                return true;
                            });

                            return true;
                        });
                        return true;
                    });
                    //Need this method as above loop gets values in structure [{date: {report}}] need in flattened structure of array of objects [{report}, {report}, etc]
                    let reports = _.flatten(flattenReports(userReports));
                    const ws_name = `${titles[reportType].substring(0, 30)}`;
                    const fileName = `${ws_name}-report.xlsx`;
                    const wb = XLSX.utils.book_new();
                    let ws = wb.Sheets[wb.SheetNames[0]];
                    ws = XLSX.utils.json_to_sheet(reports);
                    XLSX.utils.book_append_sheet(wb, ws, ws_name);
                    XLSX.writeFile(wb, fileName);
                    dispatch({ type: BUILD_EXCEL_DOC.SUCCESS });
                }
            } catch (e) {
                console.error(e);
                dispatch({ type: BUILD_EXCEL_DOC.FAIL });
            }
        } else {
            dispatch({ type: BUILD_EXCEL_DOC.FAIL });
        }
    };
};

export const getVehicleAlertReport = () => {
    return (dispatch) => {
        dispatch({ type: GET_VEHICLE_ALERTS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/subjects/alerts/new_report`)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_VEHICLE_ALERTS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else {
                    dispatch({ type: GET_VEHICLE_ALERTS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_VEHICLE_ALERTS.FAIL });
        }
    };
};

export const getHsqeTemplates = () => {
    return (dispatch) => {
        dispatch({ type: GET_HSQE_TEMPLATE.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/collections/report_templates`)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_HSQE_TEMPLATE.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else {
                    dispatch({ type: GET_HSQE_TEMPLATE.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_HSQE_TEMPLATE.FAIL });
        }
    };
};

export const specificTemplate = (data) => {
    let reference = data.replace(/ /g, "_");
    let id = `custom_${reference}`;
    return (dispatch) => {
        dispatch({ type: SET_SPECIFIC_TEMPLATE.REQUEST });
        try {
            dispatch({
                type: SET_SPECIFIC_TEMPLATE.SUCCESS,
                payload: id,
            });
        } catch {
            dispatch({ type: SET_SPECIFIC_TEMPLATE.FAIL });
        }
    };
};

const flattenReports = (reports) => {
    return reports.map((e) => {
        return Object.keys(e).map((f) => {
            return e[f];
        });
    });
};

export const getDownloads = () => {
    return (dispatch) => {
        dispatch({ type: GET_DOWNLOADS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: GET_DOWNLOADS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/subjects/downloads")
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_DOWNLOADS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_DOWNLOADS.FAIL });
        }
    };
};

export const deleteDownload = (id) => {
    return (dispatch) => {
        dispatch({ type: SET_NEW_DOWNLOAD.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: SET_NEW_DOWNLOAD.FAIL });
                }
                firebase
                    .database()
                    .ref(`/subjects/downloads`)
                    .child(`${id}`)
                    .remove();
            });
        } catch (e) {
            dispatch({ type: SET_NEW_DOWNLOAD.FAIL });
        }
    };
};

export const setNewDownload = (year, month, reportType, document_id) => {
    return (dispatch) => {
        dispatch({ type: SET_NEW_DOWNLOAD.REQUEST });
        let count_id;
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) dispatch({ type: SET_NEW_DOWNLOAD.FAIL });
                firebase
                    .database()
                    .ref(`/subjects/downloads`)
                    .once("value")
                    .then(async function (snapshot) {
                        count_id = snapshot.val(); // "last"
                        if (
                            typeof count_id !== "undefined" &&
                            count_id !== null
                        )
                            document_id = (
                                "000000" +
                                (parseInt(
                                    Object.keys(count_id)[
                                        Object.keys(count_id).length - 1
                                    ]
                                ) +
                                    1)
                            ).slice(-6);
                        else document_id = "000001";

                        firebase
                            .database()
                            .ref("/subjects/downloads")
                            .child(document_id)
                            .update({
                                doc_report_type: reportType,
                                doc_year: year,
                                doc_month: month,
                                doc_id: document_id,
                            });
                        dispatch({ type: SET_NEW_DOWNLOAD.SUCCESS });
                    });
            });
        } catch (e) {
            dispatch({ type: SET_NEW_DOWNLOAD.FAIL });
        }
    };
};
